import { render, staticRenderFns } from "./Alma.vue?vue&type=template&id=e0ecf630"
import script from "./Alma.vue?vue&type=script&lang=js"
export * from "./Alma.vue?vue&type=script&lang=js"
import style0 from "./Alma.vue?vue&type=style&index=0&id=e0ecf630&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports